import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "popup-overlay" }
const _hoisted_2 = { class: "popup__container" }
const _hoisted_3 = {
  key: 0,
  class: "popup__title"
}
const _hoisted_4 = {
  class: "text-capitalize-first",
  style: {"word-break":"break-all"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["overlay", {'overlay--active': _ctx.visible}])
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["popup", [_ctx.attrs.class, { 'popup--active': _ctx.visible }]])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.hideTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('onClose')), ["prevent"])),
                  class: "popup__close"
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("svg", {
                    width: "26",
                    height: "26",
                    viewBox: "0 0 26 26",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M13 25.8002C16.3948 25.8002 19.6505 24.4516 22.051 22.0512C24.4514 19.6507 25.8 16.395 25.8 13.0002C25.8 9.60542 24.4514 6.34969 22.051 3.94923C19.6505 1.54876 16.3948 0.200195 13 0.200195C9.60524 0.200195 6.34951 1.54876 3.94905 3.94923C1.54858 6.34969 0.200012 9.60542 0.200012 13.0002C0.200012 16.395 1.54858 19.6507 3.94905 22.0512C6.34951 24.4516 9.60524 25.8002 13 25.8002ZM10.248 8.5522C10.0205 8.34023 9.71966 8.22483 9.40878 8.23032C9.09789 8.2358 8.80128 8.36174 8.58142 8.5816C8.36156 8.80146 8.23562 9.09808 8.23013 9.40896C8.22465 9.71984 8.34004 10.0207 8.55201 10.2482L11.304 13.0002L8.55201 15.7522C8.43411 15.8621 8.33955 15.9945 8.27396 16.1417C8.20838 16.2889 8.17311 16.4478 8.17027 16.609C8.16742 16.7701 8.19706 16.9301 8.25742 17.0796C8.31777 17.229 8.4076 17.3647 8.52155 17.4787C8.6355 17.5926 8.77123 17.6824 8.92066 17.7428C9.07008 17.8031 9.23012 17.8328 9.39125 17.8299C9.55237 17.8271 9.71127 17.7918 9.85847 17.7262C10.0057 17.6607 10.1382 17.5661 10.248 17.4482L13 14.6962L15.752 17.4482C15.8619 17.5661 15.9944 17.6607 16.1416 17.7262C16.2888 17.7918 16.4477 17.8271 16.6088 17.8299C16.7699 17.8328 16.9299 17.8031 17.0794 17.7428C17.2288 17.6824 17.3645 17.5926 17.4785 17.4787C17.5924 17.3647 17.6823 17.229 17.7426 17.0796C17.803 16.9301 17.8326 16.7701 17.8298 16.609C17.8269 16.4478 17.7916 16.2889 17.7261 16.1417C17.6605 15.9945 17.5659 15.8621 17.448 15.7522L14.696 13.0002L17.448 10.2482C17.66 10.0207 17.7754 9.71984 17.7699 9.40896C17.7644 9.09808 17.6385 8.80146 17.4186 8.5816C17.1987 8.36174 16.9021 8.2358 16.5912 8.23032C16.2804 8.22483 15.9795 8.34023 15.752 8.5522L13 11.3042L10.248 8.5522Z",
                      fill: "#818B97"
                    })
                  ], -1)
                ]))
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2)
    ])
  ], 64))
}